import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionStats = ({ stats, loading = false }) => {
  const statsCards = [
    {
      title: 'Total Transactions',
      value: stats?.total?.toLocaleString() || '0',
      icon: 'Activity',
      iconColor: 'text-primary',
      iconBg: 'bg-primary/10'
    },
    {
      title: 'Success',
      value: stats?.success?.toLocaleString() || '0',
      icon: 'CheckCircle',
      iconColor: 'text-success',
      iconBg: 'bg-success/10'
    },
    {
      title: 'Pending',
      value: stats?.pending?.toLocaleString() || '0',
      icon: 'Clock',
      iconColor: 'text-warning',
      iconBg: 'bg-warning/10'
    },
    {
      title: 'Failed',
      value: stats?.failed?.toLocaleString() || '0',
      icon: 'XCircle',
      iconColor: 'text-error',
      iconBg: 'bg-error/10'
    },
    {
      title: 'Total Amount',
      value: `Rp ${(stats?.totalAmount || 0)?.toLocaleString('id-ID')}`,
      icon: 'DollarSign',
      iconColor: 'text-primary',
      iconBg: 'bg-primary/10'
    },
    {
      title: 'Success Rate',
      value: `${(stats?.successRate || 0)?.toFixed(1)}%`,
      icon: 'TrendingUp',
      iconColor: 'text-success',
      iconBg: 'bg-success/10'
    }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
        {[...Array(6)]?.map((_, i) => (
          <div key={i} className="bg-card border border-border rounded-xl p-4 shadow-sm animate-pulse">
            <div className="h-4 bg-muted rounded w-1/2 mb-3"></div>
            <div className="h-8 bg-muted rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
      {statsCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-start justify-between mb-3">
            <p className="text-xs text-muted-foreground">{stat?.title}</p>
            <div className={`p-1.5 rounded-lg ${stat?.iconBg}`}>
              <Icon name={stat?.icon} size={16} className={stat?.iconColor} />
            </div>
          </div>
          <p className="text-xl font-bold text-foreground">{stat?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default TransactionStats;